/**
 * Icons Payment Methods Enum
 */
export enum IconsPaymentMethods {
  card = "card-icon",
  credit_card = "card-icon",
  debit_card = "card-icon",
  transfer = "transfer-icon",
  cash = "cash-icon",
  payouts_cash = "payouts_cash-icon",
  card_dynamic = "card_dynamic-icon",
  card_async = "card_async-icon",
  card_subscription_dynamic = "card_subscription_dynamic-icon",
}



// WEBPACK FOOTER //
// ./src/shared/IconsPaymentMethods.ts